import { render, staticRenderFns } from "./NewLoadFile.vue?vue&type=template&id=154eb906&"
import script from "./NewLoadFile.vue?vue&type=script&lang=js&"
export * from "./NewLoadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports